export default __webpack_public_path__ + "static/media/powered-by-finmobile-color.4e327327.png";